import { render, staticRenderFns } from "./vRemisiones.vue?vue&type=template&id=2c711087&scoped=true"
import script from "./vRemisiones.vue?vue&type=script&lang=js"
export * from "./vRemisiones.vue?vue&type=script&lang=js"
import style0 from "./vRemisiones.vue?vue&type=style&index=0&id=2c711087&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c711087",
  null
  
)

export default component.exports